module.exports = __webpack_public_path__ + "static/media/calendar.0448c8fd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/teachers/noticeboard/calendar.svg
// module id = 563
// module chunks = 0